import React from 'react'
import { useContext } from 'react'
import { Route, Link, Switch, useLocation, useRouteMatch} from 'react-router-dom'
import BookTripDetails from './BookTripDetails'
import BookTripFlextime from './BookTripFlextime'
import MyLocation from '../comps/MyLocation.js'
import TripInfo from '../comps/TripInfo'
import {AppContext} from '../context/AppContext'

const BookTripDone = () => {
  let match = useRouteMatch()
  const location = useLocation()
  console.log(match.path)
  const {tripDetails, prevPage, setPrevPage, nextPage, setNextPage, infoShow, setInfoShow} = useContext(AppContext)
  setInfoShow(true)

  return (
   <div id="booktrip-done" className="content">
    
          <h2>Your booking is confirmed</h2>
          <TripInfo />
          <div className="what-now box">
            <h3>What will happen now?</h3>
            <p>Your flexible booking has been registered. Two days before departure day your trip will be set and you will recieve updated travel details.
            </p>
            <h4>Thank you for using Volta Electric Flight</h4>
            <div className="button-group">
              <Link to="iphonescreen" className="button ok-button"><h3>Ok!</h3></Link>
            </div>
          </div>
        
      </div>
  )
}

export default BookTripDone
